module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma/hero_mob-a5261ee85dc600829dff72b52bab5c34.png";